import {request} from 'api';
import {LocaleData} from 'contexts/LocaleContext';
import {SearchResult} from 'models/search';

interface SearchQueryData {
    query: string;
    page: number;
    type?: string;
}

export function searchFull({code}: LocaleData, queryData: SearchQueryData) {
    return request<SearchResult>({
        method: 'GET',
        url: '/api/search/all',
        params: {localeCode: code, ...queryData},
    });
}

export function searchForSuggest({code}: LocaleData, query: string) {
    return request<SearchResult>({
        method: 'GET',
        url: '/api/search/suggest',
        params: {localeCode: code, query},
    });
}
